export function plainText(value: string | number | readonly string[] | null | undefined): string {
  if (value === null || value === undefined) {
    return ''
  }
  return Array.isArray(value) ? value.join(', ') : String(value)
}
